<template>

    <div>

        <skoly-menu
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <main class="profileDashboard skolska-sekcia-main justify-content-center">

            <article>

                <aside class="rounded-10 bg-white position-relative p-50">
                    <h3>Žiaci v našej triede</h3>

                    <form @submit.prevent="addZiak">
                        <div class="form-row">
                            <div class="col-12 col-md-12">
                                <div class="position-relative ziak-input-group">
                                    <input type="text" class="form-control form-control-lg" name="pridat-ziaka" id="pridat-ziaka" placeholder="Pridajte žiaka do triedy, napíšte meno ..." v-model="novyZiak">
                                    <button class="btn --secondary" type="submit">pridať žiaka</button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="d-flex align-items-center justify-content-between mb-20">
                        <p class="mb-0 text-uppercase"><b class="text-dark">zoznam žiakov</b></p>
<!--                        <p class="mb-0">Pridaných žiakov: <b class="text-primary">25</b></p>-->
                    </div>
                    <ul class="ziaci hover-delete">
                        <li v-for="(ziak, index) in zoznamZiakov" :key="index">
                            <span class="icon icon--user mr-10 text-icon"></span>
                            <span class="icon icon--delete mr-10 text-primary" @click="removeZiak(index)"></span>
                            {{ ziak }}
                        </li>
                    </ul>
                </aside>

            </article>
            <aside>
                <div class="m-skolskaKarta mb-50">

                    <h5 class="a-skolskaKarta__title">žiakov v našej triede</h5>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="a-skolskaKarta__value text-primary">{{ zoznamZiakov.length }}</div>
                    </div>

                </div>

                <div class="pl-50 pr-50">
                    <span class="icon icon--info text-icon mb-20 text-21"></span>
                    <p class="line-24">V tejto sekcii pani učiteľka/pán učiteľ pridá krstné mená všetkých detí zo svojej triedy. V niektorých tvorivých úlohách počet žiakov určuje, kedy je úloha splnená na 100% - napríklad pre triedu, v ktorej je 15 detí pani učiteľka/pán učiteľ zadá 15 mien a 100% splnenú úlohu bude mať kolektív keď do vypracovania úlohy nahrá 15 obrázkov.</p>
                </div>
            </aside>

        </main>
    </div>
</template>

<script>
import EventService from '@/services/EventService.js'
import SkolyMenu from "@/components/skoly/SkolyMenu.vue";

export default {
    components: {
        SkolyMenu,
    },
    props: [
        'profil',
    ],
    data() {
        return {
            novyZiak: '',
            zoznamZiakov: []
        }
    },
    mounted() {
        if ( this.profil && this.profil.pouzivatel_id && this.profil.pouzivatel_id.pouzivatel_ziaci ) {
            this.zoznamZiakov = JSON.parse(this.profil.pouzivatel_id.pouzivatel_ziaci)
        }
    },
    methods: {
        // emit
        emitUpdateProfil() {
            this.$emit('updateProfil')
        },

        async addZiak() {
            if ( this.novyZiak.trim() ) {
                this.zoznamZiakov.push( this.novyZiak )
                this.novyZiak = ''
            }

            await EventService.changePouzivatelZiaci(this.profil.pouzivatel_id.id, this.zoznamZiakov)
            this.emitUpdateProfil()
        },

        async removeZiak(index) {
            this.zoznamZiakov.splice(index, 1)

            await EventService.changePouzivatelZiaci(this.profil.pouzivatel_id.id, this.zoznamZiakov)
            this.emitUpdateProfil()
        },

    },
    watch: {
        profil: {
           deep: true,
           handler(profil) {
               this.zoznamZiakov = JSON.parse(profil.pouzivatel_id.pouzivatel_ziaci)
           }
        }
    }

}
</script>
